import {
    CANCEL_BOOKING_POLICY_START,
    CANCEL_BOOKING_POLICY_SUCCESS,
    CANCEL_BOOKING_POLICY_ERROR
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: []
      // data:null
      
  };
  
  export default function CanellationPolicyReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case CANCEL_BOOKING_POLICY_START:
        return {
          ...state,
          loading: true,
        };
      case CANCEL_BOOKING_POLICY_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case CANCEL_BOOKING_POLICY_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  